import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface ScrollableProps {
  children: ReactNode;
  className?: string;
}

export function Scrollable({ children, className }: ScrollableProps) {
  return (
    <div className={cn('relative flex-1 h-full w-full', className)}>
      <div className="absolute inset-0 overflow-auto" tabIndex={0}>
        {children}
      </div>
    </div>
  );
}
